import { render, staticRenderFns } from "./CreateAccountButton.vue?vue&type=template&id=2189503a&"
import script from "./CreateAccountButton.vue?vue&type=script&lang=js&"
export * from "./CreateAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CreateAccountButton.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2189503a')) {
      api.createRecord('2189503a', component.options)
    } else {
      api.reload('2189503a', component.options)
    }
    module.hot.accept("./CreateAccountButton.vue?vue&type=template&id=2189503a&", function () {
      api.rerender('2189503a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/CreateAccountButton.vue"
export default component.exports